import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IS_ACTION, IS_LOAD, IS_SEARCH } from 'src/app/shared/models/load.models';
import { EnvironmentFacadeService } from 'src/app/shared/services/environment.facade.service';
import { GridFacadeService } from 'src/app/shared/services/grid.facade.service';
import { AttributesCodes, CampaignAdHocListItem } from '../models/lists.model';
import { ListsFacadeService } from './lists.facade.service';

@Injectable({ providedIn: 'root' })
export class ListsService {
  constructor(
    private http: HttpClient,
    private environmentFacade: EnvironmentFacadeService,
    private listsFacade: ListsFacadeService,
    private gridFacadeService: GridFacadeService,
  ) {}

  getTargets(): Observable<any[]> {
    const url = `${this.environmentFacade.getEnvironment()}/rest/v1/campaigns/enums`;
    return this.http.get<any[]>(url, {
      withCredentials: true,
      context: new HttpContext().set(IS_LOAD, true),
    });
  }

  getLists(): Observable<CampaignAdHocListItem[]> {
    const url = `${this.environmentFacade.getEnvironment()}/rest/v1/campaigns/adhoclist/byFilter`;

    const body = {
      listName: this.listsFacade.name,
      listNotes: this.listsFacade.description,
      target: this.listsFacade.target,
    };

    return this.http.post<CampaignAdHocListItem[]>(url, body, {
      withCredentials: true,
      context: new HttpContext().set(IS_SEARCH, true),
    });
  }

  downloadList(data: any): Observable<any> {
    const campaignAdHocListId = data.campaignAdHocListId;
    const url = `${this.environmentFacade.getEnvironment()}/rest/v1/campaigns/adhoclist/exportList?campaignAdHocListId=${campaignAdHocListId}`;

    return this.http.get<any>(url, {
      withCredentials: true,
      responseType: 'text' as 'json',
      context: new HttpContext().set(IS_ACTION, true),
    });
  }

  deleteList(): Observable<any> {
    const id = this.gridFacadeService.selectedRow.campaignAdHocListId;
    const url = `${this.environmentFacade.getEnvironment()}/rest/v1/campaigns/adhoclist/?id=${id}`;

    return this.http.delete<any>(url, {
      withCredentials: true,
      context: new HttpContext().set(IS_ACTION, true),
    });
  }

  getAttributeCodes(): Observable<AttributesCodes[]> {
    const url = `${this.environmentFacade.getEnvironment()}/rest/v1/system/attribute-codes`;
    return this.http.get<AttributesCodes[]>(url, {
      withCredentials: true,
      context: new HttpContext().set(IS_LOAD, true),
    });
  }
}
